import PropTypes from 'prop-types';
import React from 'react';

import Modal from 'components/Modal';
import Video from 'components/VideoPlayer';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const VideoModal = ({ isOpen, closeModal, modalSettings, videoUrl, ...otherProps }) => {
  const playerSettings = {
    controls: true,
    playing: true,
  };

  return (
    <Modal
      isOpen={isOpen}
      className="VideoModal__content"
      portalClassName="VideoModal__portal"
      onRequestClose={closeModal}
      {...modalSettings}
    >
      <div className="VideoModal__video">
        <Video {...otherProps} url={videoUrl} {...playerSettings} />
      </div>
      <style jsx>{`
        @media ${largeUp} {
          .VideoModal__video {
            width: 65vw;
            max-width: 100%;
          }
        }
      `}</style>
      <style jsx global>
        {`
          .VideoModal__content.Modal__content {
            padding: 0;
            overflow: hidden;
            min-width: 100vw;
          }

          .VideoModal__content .CloseIcon:before,
          .VideoModal__content .CloseIcon:after {
            background-color: ${Theme.get('colors-white')};
          }

          .VideoModal__content.CloseIcon.focused {
            outline: 2px solid ${Theme.get('colors-white')};
          }

          @media ${largeUp} {
            .VideoModal__content.Modal__content {
              min-width: auto;
            }
          }
        `}
      </style>
    </Modal>
  );
};

VideoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalSettings: PropTypes.shape({}),
  videoUrl: PropTypes.string.isRequired,
};

VideoModal.defaultProps = {
  modalSettings: {},
};

export default VideoModal;
